(function(){
    angular
        .module('appback')
        .directive('copyToClipboard', copytoclipboard);

        copytoclipboard.$inject = ['$timeout'];
        function copytoclipboard($timeout){
            return {
	            restrict: 'A',
	            link: function(scope, element, attrs, modelCtrl) {
	            	element.click(function () {
                    if (attrs.copyToClipboard) {
                        var $temp_input = $("<input>");
                        $("body").append($temp_input);
                        $temp_input.val(attrs.copyToClipboard).select();
                        document.execCommand("copy");
                        $temp_input.remove();
                    }
                });
				}
        	}
        }
})();